'use strict';

exports.__esModule = true;

var _object = require('./object');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertySet = function () {
  function PropertySet(properties) {
    _classCallCheck(this, PropertySet);

    this.properties = properties || {};
  }

  PropertySet.prototype.clear = function clear() {
    this.properties = {};
  };

  PropertySet.prototype.get = function get(name) {
    if (this.properties.hasOwnProperty(name)) {
      return this.properties[name];
    }
  };

  PropertySet.prototype.set = function set(name, value) {
    this.properties[name] = value;
  };

  PropertySet.prototype.isSet = function isSet(name) {
    if (this.properties.hasOwnProperty(name)) {
      return true;
    }
  };

  PropertySet.prototype.delete = function _delete(name) {
    delete this.properties[name];
  };

  PropertySet.prototype.getProperties = function getProperties(fnIgnore) {
    var returnProps = {};
    var _fnIgnore = function _fnIgnore() {
      return false;
    };
    if (!fnIgnore && typeof fnIgnore === 'function') {
      _fnIgnore = fnIgnore;
    }
    (0, _object.map)(this.properties, function (key, value) {
      if (_fnIgnore(key)) {
        return;
      }
      returnProps[key] = value;
    });
    return returnProps;
  };

  PropertySet.prototype.merge = function merge(properties) {
    var _this = this;

    var mergeObject = properties;
    if (mergeObject instanceof PropertySet) {
      mergeObject = properties.getProperties();
    }
    (0, _object.map)(mergeObject, function (key, value) {
      _this.set(key, value);
    });
  };

  return PropertySet;
}();

exports.default = PropertySet;